<template>
  <div>
    <p class="cm-mg-p-wzd">2. {{ $t('irrigation.engine_detailed_info') }}</p>
    <hr />
    <br />
    <div class="row">
      <div class="col-md-4">
        <fg-input
          type="number"
          :label="`${$t('irrigation.nozzle')}: *`"
          v-model="model.nozzle"
          name="irrigation.nozzle"
          :placeholder="$t('irrigation.nozzle')"
          v-validate="'required'"
          :error="getError('irrigation.nozzle', true)"
        ></fg-input>
      </div>
      <div class="col-md-4">
        <fg-input
          type="number"
          :label="`${$t('irrigation.sprinkling')}: *`"
          v-model="model.aspersion_ha"
          name="irrigation.sprinkling"
          :placeholder="$t('irrigation.sprinkling')"
          v-validate="'required'"
          :error="getError('irrigation.sprinkling', true)"
        ></fg-input>
      </div>
      <div class="col-4">
        <fg-input
          type="number"
          :label="`${$t('irrigation.efficiency')}: *`"
          :placeholder="$t('irrigation.efficiency')"
          v-model="model.efficiency"
          name="irrigation.efficiency"
          v-validate="'required'"
          :error="getError('irrigation.efficiency', true)"
        ></fg-input>
      </div>
      <div class="col-4">
        <fg-input
          type="number"
          :label="`${$t('irrigation.plate')}: *`"
          :placeholder="$t('irrigation.plate_normal')"
          v-model="model.lamina"
          name="irrigation.plate_normal"
          v-validate="'required'"
          :error="getError('irrigation.plate_normal', true)"
        ></fg-input>
      </div>
      <div class="col-4">
        <fg-input
          type="number"
          :label="`${$t('irrigation.real_psi')}: *`"
          :placeholder="$t('irrigation.engine_inputed_psi')"
          v-model="model.psi_real"
          name="irrigation.real_psi_normal"
          v-validate="'required'"
          :error="getError('irrigation.real_psi_normal', true)"
        ></fg-input>
      </div>
      <div class="col-4">
        <fg-input
          type="number"
          :label="`${$t('irrigation.irrigation_area_ha')}: *`"
          :placeholder="
            placeholderArea == null
              ? $t('irrigation.irrigation_area')
              : placeholderArea
          "
          v-model="model.irrigation_area"
          name="irrigation.irrigation_area"
          v-validate="'required'"
          :error="getError('irrigation.irrigation_area', true)"
        ></fg-input>
      </div>
      <div class="col-4">
        <div class="form-group has-label">
          <label>{{ $t('irrigation.irrigation_blocks') }}: </label>
          <br />
          <el-select
            collapse-tags
            clearable
            multiple
            :disabled="hasData"
            class="select-primary custom-width-select bus-rels shadow-sm"
            size="large"
            v-model="model.block_ids"
            :placeholder="`${$t('common_words.select')}...`"
            filterable
            @change="
              onBlockChange();
              selectAllFromSelect('model.block_ids', blocks);
            "
          >
            <el-option
              v-for="option in blocks"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="option.name"
            ></el-option>
          </el-select>
          <!-- <fg-input
                type="number"
                label="Bloques de riego: *"
                placeholder="Num. Bloques de riego"
                v-model="model.irrigation_blocks"
                name="Num. Bloques de riego"
                v-validate="'required'"
                :error="getError('Num. Bloques de riego')"
              ></fg-input> -->
        </div>
      </div>
      <div class="col-4">
        <div class="form-group has-label">
          <label>{{ $t('irrigation.hourmeter') }} *</label>
          <el-select
            clearable
            :label="$t('irrigation.hourmeter')"
            class="select-primary custom-width-select bus-rels shadow-sm"
            size="large"
            v-model="model.hourmeter_name"
            :placeholder="`${$t('common_words.select')}...`"
            filterable
          >
            <el-option
              v-for="option in [
                { option: $t('common_words.mayus_yes'), value: 'SI' },
                { option: $t('common_words.mayus_no'), value: 'NO' },
              ]"
              class="select-primary"
              :value="option.value"
              :label="option.option"
              :key="option.option"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-4">
        <div class="form-group has-label">
          <label>{{ $t('irrigation.hydrometer') }} *</label>
          <el-select
            clearable
            :label="$t('irrigation.hydrometer')"
            class="select-primary custom-width-select bus-rels shadow-sm"
            size="large"
            v-model="model.hydrometer_name"
            :placeholder="`${$t('common_words.select')}...`"
            filterable
          >
            <el-option
              v-for="option in [
                { option: $t('common_words.mayus_yes'), value: 'SI' },
                { option: $t('common_words.mayus_no'), value: 'NO' },
              ]"
              class="select-primary"
              :value="option.value"
              :label="option.option"
              :key="option.option"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';
import { Axios } from 'src/class/Axios.js';

export default {
  components: {},

  props: {
    blocks: {
      type: Array,
      required: true,
    },
    wizardModel: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      model: {
        nozzle: null,
        aspersion_ha: null,
        efficiency: null,
        lamina: null,
        psi_real: null,
        irrigation_area: null,
        hourmeter_name: null,
        hydrometer_name: null,
        hourmeter: null,
        hydrometer: null,
        block_ids: [],
        irrigation_blocks: null,
      },
      placeholderArea: null,
      hasData: false,
    };
  },

  mixins: [MixinPermissions, MixinForm, mixinMasters],

  methods: {
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', res, this.model);
        // this.$emit("fillWizardForm", "secondStep");
        return res;
      });
    },

    onBlockChange() {
      Axios.postMasters({
        route: 'block/area',
        blocks: this.model.block_ids,
        farm_id: this.wizardModel.farm_id,
      })
        .then((response) => {
          this.placeholderArea = response.data.data.area;
          this.model.irrigation_area = response.data.data.area;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.nozzle = editForm.nozzle;
      this.model.aspersion_ha = editForm.aspersion_ha;
      this.model.efficiency = editForm.efficiency;
      this.model.lamina = editForm.lamina;
      this.model.psi_real = editForm.psi_real;
      this.model.irrigation_area = editForm.irrigation_area;
      this.model.irrigation_blocks = editForm.irrigation_blocks;
      this.model.hourmeter_name = editForm.hourmeter;
      this.model.hydrometer_name = editForm.hydrometer;
      this.model.block_ids =
        editForm.block_ids[0] == 0 ? [] : editForm.block_ids;
    }
  },

  updated() {
    if (this.model.irrigation_blocks != this.model.block_ids.length) {
      this.model.irrigation_blocks = this.model.block_ids.length;
    }
  },

  created() {
    this.showHideLoading(true);
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      Axios.getMasters(
        `irrigation/engine/hasData/${
          JSON.parse(sessionStorage.getItem('editForm')).id
        }`
      )
        .then((response) => {
          this.hasData = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
        });
    }
  },
};
</script>
